import React, { useState } from "react";
import "../styles/SignupPage.css";
import TextBox from "../components/TextBox";
import api from "../api/api";
import { Link, useNavigate } from "react-router-dom";

const SignupPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async () => {
    try {
      const response = await api.post("/auth/signup/", {
        username: formData.username,
        password: formData.password,
        password2: formData.confirmPassword,
      });

      if (response.status === 201 || response.status === 200) {
        alert("Signup successful! Please log in.");
        navigate("/login"); // Redirect after success
      } else {
        const errorData = await response.json();
        console.error("Signup failed:", errorData);
        alert("Signup failed.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Signup failed.");
    }
  };

  return (
    <div className="signup-page">
      <h1 className="signup-title">Join Us</h1>
      <p className="signup-subtitle">
        Create your account and start your wellness journey
      </p>

      <div className="signup-card">
        {/* Card Header */}
        <div className="card-header">
          <h2 className="card-title">Create Account</h2>
          <p className="card-description">
            Fill in your details to get started
          </p>
        </div>

        {/* Card Content */}
        <div className="card-content">
          <div className="name-row">
            <div className="input-group">
              <label className="input-box-title">First Name</label>
              <TextBox
                placeholder="John"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label className="input-box-title">Last Name</label>
              <TextBox
                placeholder="Doe"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="input-group">
            <label className="input-box-title">Username</label>
            <TextBox
              type="username"
              placeholder="you@example.com"
              name="username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label className="input-box-title">Password</label>
            <TextBox
              type="password"
              placeholder="Enter password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label className="input-box-title">Confirm Password</label>
            <TextBox
              type="password"
              placeholder="Re-enter password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
          </div>

          <div className="terms-row">
            <input type="checkbox" id="terms" />
            <label htmlFor="terms">
              I agree to the <a href="#">Terms of Service</a> and{" "}
              <a href="#">Privacy Policy</a>
            </label>
          </div>

          <button className="create-account-btn" onClick={handleSignup}>
            Create Account
          </button>

          <p className="login-prompt">
            Already have an account? <Link to="/login">Login here</Link>
          </p>
        </div>
      </div>

      <p className="signup-note">
        Your data is secured and will never be shared with third parties.
      </p>
    </div>
  );
};

export default SignupPage;
